/* ZED Free Express Post (spec 71_; accessory pages, spec 73_). New file, not part of Athens: a theme update leaves it alone.
   Fills in the countdown, the dispatch day and the arrival dates for elements rendered by
   snippets/zed-delivery-promise.liquid.

   Rules (David, 13 Oct 2026):
   - Same-day dispatch for orders placed by 3pm Brisbane time on a business day (Mon-Fri, not a holiday).
   - Kits go Express Post: arrives dispatch day + 1 to 3 business days (metro).
   - Accessories on their own go Standard Post: dispatch day + 2 to 6 business days.
   Brisbane is UTC+10 all year (no daylight saving), so the maths runs on a UTC clock shifted by 10 hours
   and gives the same answer whatever time zone the shopper's device is in. */
(function () {
  if (window.zedDeliveryPromise) return;
  window.zedDeliveryPromise = true;

  var DAY = 86400000;
  var QLD_OFFSET = 10 * 3600000;
  var CUTOFF_HOUR = 15;
  var SHORT_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var FULL_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var SERVICES = { express: [1, 3], standard: [2, 6] };

  var holidays = null;

  function loadHolidays() {
    if (holidays) return;
    holidays = {};
    var el = document.querySelector('[data-holidays]');
    var raw = el ? el.getAttribute('data-holidays') || '' : '';
    raw.split(',').forEach(function (s) {
      s = s.trim();
      if (s) holidays[s] = true;
    });
  }

  function key(d) {
    return d.getUTCFullYear() + '-' + String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0');
  }
  function isBusinessDay(d) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidays[key(d)];
  }
  function nextBusinessDay(d) {
    var x = new Date(d.getTime());
    do { x = new Date(x.getTime() + DAY); } while (!isBusinessDay(x));
    return x;
  }
  function addBusinessDays(d, n) {
    var x = d;
    for (var i = 0; i < n; i += 1) x = nextBusinessDay(x);
    return x;
  }
  function range(a, b) {
    var left = SHORT_DAYS[a.getUTCDay()] + ' ' + a.getUTCDate() + (a.getUTCMonth() === b.getUTCMonth() ? '' : ' ' + MONTHS[a.getUTCMonth()]);
    return left + ' – ' + SHORT_DAYS[b.getUTCDay()] + ' ' + b.getUTCDate() + ' ' + MONTHS[b.getUTCMonth()];
  }

  /* Everything else is worked out from this one snapshot of "now" in Brisbane. */
  function snapshot() {
    loadHolidays();
    var now = new Date(Date.now() + QLD_OFFSET);
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var cutoff = today.getTime() + CUTOFF_HOUR * 3600000;
    var beforeCutoff = isBusinessDay(today) && now.getTime() < cutoff;
    var dispatch = beforeCutoff ? today : nextBusinessDay(today);
    var tomorrow = new Date(today.getTime() + DAY);
    return {
      now: now,
      cutoff: cutoff,
      beforeCutoff: beforeCutoff,
      dispatch: dispatch,
      shipsWord: key(dispatch) === key(tomorrow) ? 'tomorrow' : FULL_DAYS[dispatch.getUTCDay()]
    };
  }

  /* Fills a data-tpl line: the date range and "to metro areas" each stay on one line. */
  function fillTpl(el, s, service) {
    var html = el.getAttribute('data-tpl')
      .replace('{range}', '<span class="zed-nowrap">' + arrival(s, service) + '</span>')
      .replace(' to metro areas', ' <span class="zed-nowrap">to metro areas</span>');
    el.innerHTML = html;
  }

  function arrival(s, service) {
    var span = SERVICES[service] || SERVICES.express;
    return range(addBusinessDays(s.dispatch, span[0]), addBusinessDays(s.dispatch, span[1]));
  }

  function countdownHTML(s) {
    if (s.beforeCutoff) {
      var mins = Math.max(1, Math.ceil((s.cutoff - s.now.getTime()) / 60000));
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      var left = h > 0 ? h + ' h' + (m > 0 ? ' ' + m + ' min' : '') : m + ' min';
      return 'Order in the next <b>' + left + '</b> and it ships today.';
    }
    return 'Order now and it ships <b>' + s.shipsWord + '</b>.';
  }

  /* ---------- Kit page: is the chosen variant in stock (ships now)? ---------- */
  function currentVariantId() {
    var input = document.querySelector('.product-block-product-form form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('product-form form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function variantShipsNow(card) {
    var json = card.querySelector('[data-zed-dp-variants]');
    if (!json) return true;
    var map;
    try { map = JSON.parse(json.textContent); } catch (e) { return true; }
    var id = currentVariantId();
    if (!id || !(id in map)) return true;
    return map[id] === 1;
  }

  /* ---------- Paint every element on the page ---------- */
  function paint() {
    var s = snapshot();

    document.querySelectorAll('[data-zed-dp-bar]').forEach(function (el) {
      el.textContent = s.beforeCutoff ? 'Order by 3pm (QLD time), ships today' : 'Order now, ships ' + s.shipsWord;
    });

    document.querySelectorAll('[data-zed-dp="product"]').forEach(function (card) {
      var ready = variantShipsNow(card);
      var cd = card.querySelector('[data-zed-dp-countdown]');
      /* Accessory pages (spec 73_) put the countdown in a head row with a truck: hide the whole row with it. */
      var head = cd ? cd.closest('.zed-dp-two-head') : null;
      if (cd) {
        if (ready) {
          cd.innerHTML = countdownHTML(s);
          cd.classList.remove('zed-dp-pending', 'zed-dp-off');
          if (head) head.classList.remove('zed-dp-off');
        } else {
          cd.classList.add('zed-dp-off');
          if (head) head.classList.add('zed-dp-off');
        }
      }
      /* One card can carry two arrival lines (Standard on its own, Express with a kit); each names its own service. */
      card.querySelectorAll('[data-zed-dp-arrival]').forEach(function (arr) {
        if (ready) {
          fillTpl(arr, s, arr.getAttribute('data-service') || card.getAttribute('data-service'));
        } else {
          arr.textContent = arr.getAttribute('data-fallback');
        }
      });
    });

    document.querySelectorAll('[data-zed-dp="cart-banner"] [data-service]').forEach(function (card) {
      var arr = card.querySelector('[data-zed-dp-arrival]');
      if (arr) fillTpl(arr, s, card.getAttribute('data-service'));
    });
  }

  /* ---------- Cart page ---------- */
  function placeCartBanner() {
    var banner = document.querySelector('[data-zed-dp="cart-banner"]');
    var title = document.getElementById('cart-page-title-wrap');
    if (banner && title && title.nextElementSibling !== banner) {
      title.parentNode.insertBefore(banner, title.nextSibling);
    }
  }

  /* When the cart changes (quantity, remove), fetch fresh copies of our cart elements from Shopify
     (Section Rendering API) so "kit in cart" vs "accessories only" stays right. */
  var refreshTimer = null;
  function refreshCartElements() {
    var els = document.querySelectorAll('[data-zed-dp-refresh][data-section-id]');
    if (!els.length) return;
    var bySection = {};
    els.forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      (bySection[id] = bySection[id] || []).push(el);
    });
    Object.keys(bySection).forEach(function (sectionId) {
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          bySection[sectionId].forEach(function (el) {
            var fresh = doc.querySelector('[data-zed-dp-refresh="' + el.getAttribute('data-zed-dp-refresh') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          paint();
        })
        .catch(function () {});
    });
  }
  function watchCart() {
    var items = document.getElementById('main-cart-items');
    if (!items || !window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshCartElements, 600);
    }).observe(items, { childList: true, subtree: true });
  }

  /* ---------- Start ---------- */
  var paintTimer = null;
  function paintSoon() {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(paint, 350);
  }

  function start() {
    if (!document.querySelector('[data-zed-dp]')) return;
    placeCartBanner();
    paint();
    setInterval(paint, 30000);
    document.addEventListener('change', paintSoon);
    document.addEventListener('variant:change', paintSoon);
    document.addEventListener('productVariantChange', paintSoon);
    window.addEventListener('popstate', paintSoon);
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
